import React, { useState } from "react";
import "./Signin.css";

function Signin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch("https://himchatterjee.in/backend/admin_login.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (data.success) {
      setSuccess("Login Successful 🎉");
      setError("");

      // ✅ yaha login flag save karo
      localStorage.setItem("isLoggedIn", "true");

      // redirect to admin dashboard page
      window.location.href = "/admin/dashboard";
    } else {
      setError(data.message);
      setSuccess("");
    }

  };

  return (
    <div className="signin-container">
      <div className="signin-box">
        <h1 className="title">🎨 Him Chatterjee Admin</h1>
        <p className="subtitle">Login to manage your artworks & website</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
      </div>
    </div>
  );
}

export default Signin;
